export const checkForGreaterThanOneWeek = (
  startDateStr: string | Date | null,
  endDateStr: string | Date | null
): boolean => {
  if (!startDateStr || !endDateStr) {
    return false;
  }
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Normalize dates to midnight to avoid time-of-day issues
  const startDateNormalized = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate()
  );
  const endDateNormalized = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate()
  );

  const diffMs = endDateNormalized.getTime() - startDateNormalized.getTime();
  const diffDays = diffMs / (1000 * 60 * 60 * 24);

  // Both types check for > 7 days (i.e., >= 8 days) to match "no more than 7 days" rule
  // 7 days is allowed, 8+ days should be flagged
  return diffDays > 7;
};
